import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ReportVerifyPopupComponent } from './report-verify-popup.component';
import { MaterialModule } from "../../material/material.module";



@NgModule({
  declarations: [ReportVerifyPopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,   
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MaterialModule
]
})
export class ReportVerifyPopupModule { }
